import { PerspectiveCamera } from "three";
import { PanoCameraBehavior } from "../../behaviors/internal";
import { Camera } from "./internal";
/**
 * Panorama Scene camera. Derived class, just an ordinary perspective camera
 *
 * @author benjamin loesch
 *
 * @class PerspectiveCamera
 * @param {SceneGraphNode} parentNode
 * @extends {Camera}
 * @constructor
 */
export class PanoCamera extends Camera {
    /**
     * @method constructor
     * @param {SceneGraphNode} parentNode
     * @parram {TraversalState} traversalState
     */
    constructor(parentNode) {
        super(parentNode);
        const sc = parentNode.sceneCamera.iCamera;
        this.iCamera = new PerspectiveCamera(90, this.parentNode.engine.getContextWidth() / this.parentNode.engine.getContextHeight(), sc.near, sc.far);
        this._panoSceneCameraBehavior = new PanoCameraBehavior(this, [0, 0, 0], [0, 0, 0]);
        this.addBehavior(this._panoSceneCameraBehavior);
    }
    /**
     * writes : traversalstate.scenecamera
     *
     * @method init
     * @param {TraversalState} traversalState
     */
    init(traversalState) {
        super.init(traversalState);
    }
    /**
     * @method getWidth
     * @return {number}
     */
    getWidth() {
        return this.iCamera.fullWidth;
    }
    /**
     * @method getHeight
     * @return {number}
     */
    getHeight() {
        return this.iCamera.fullHeight;
    }
    /**
     * @method setPosition
     * @param {number[]} position
     */
    setPosition(position) {
        this._panoSceneCameraBehavior.setPosition(position);
    }
    getZoomLevel() {
        return this._panoSceneCameraBehavior.zoom;
    }
    /**
     * @method getPosition
     * @return {Vector3}
     */
    getPosition() {
        return this._panoSceneCameraBehavior.position.clone();
    }
    /**
     * @method getPositionAbsolute
     * @return {Vector3}
     */
    getPositionAbsolute() {
        return this._panoSceneCameraBehavior.positionAbsolute.clone();
    }
    /**
     * @method setOrientation
     * @param {number[]} orientation
     */
    setOrientation(orientation) {
        this._panoSceneCameraBehavior.setOrientation(orientation);
    }
    /**
     * getOrientation
     * @returns {Vector3}
     */
    getOrientation() {
        return this._panoSceneCameraBehavior.orientation.clone();
    }
    /**
     * Sets lat lon direct, direct, without movement animation
     * @param lat
     * @param lon
     * @param fov
     */
    setInitLatLon(lat, lon, fov) {
        this._panoSceneCameraBehavior.setLatLon(lat, lon, true, fov);
    }
    /**
     * Sets lat lon with movement animation
     * @param lat
     * @param lon
     * @param fov
     */
    setLatLon(lat, lon, fov) {
        this._panoSceneCameraBehavior.setLatLon(lat, lon, false, fov);
    }
    /**
     *
     * @returns latitude, longitude, field of view
     */
    getLatLon() {
        return this._panoSceneCameraBehavior.getLatLon();
    }
    setCameraIntrinsics(cameraIntrinsics) {
        this._panoSceneCameraBehavior.setCameraIntrinsics(cameraIntrinsics);
    }
    setFovLimits(minFov, maxFov) {
        this._panoSceneCameraBehavior.setFovLimits(minFov, maxFov);
    }
}
//# sourceMappingURL=panocamera.js.map